import { render, staticRenderFns } from "./sidebarRight.vue?vue&type=template&id=05e643b0&scoped=true&"
import script from "./sidebarRight.vue?vue&type=script&lang=js&"
export * from "./sidebarRight.vue?vue&type=script&lang=js&"
import style0 from "./sidebarRight.vue?vue&type=style&index=0&id=05e643b0&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05e643b0",
  null
  
)

export default component.exports